module.exports = __webpack_public_path__ + "assets/img/2041591928118_.pic_hd.e6f02374.jpg";